import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "privacy-body ion-padding" }
const _hoisted_2 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { class: "privacy-header" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: _ctx.arrowBackOutline }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("Политика конфиденциальности", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        class: "main-background privacy-content",
        fullscreen: true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _cache[6] || (_cache[6] = _createElementVNode("p", { class: "privacy-intro" }, " Настоящая Политика конфиденциальности приложения «Лига тренеров» (далее — Приложение) определяет порядок обработки персональных данных пользователей и действует в отношении всех данных, которые Национальная лига тренеров (далее — Оператор) может получить о пользователе во время использования Приложения. ", -1)),
            _cache[7] || (_cache[7] = _createElementVNode("h2", null, "1. Общие положения", -1)),
            _cache[8] || (_cache[8] = _createElementVNode("p", null, " Использование Приложения означает согласие пользователя с настоящей Политикой конфиденциальности и условиями обработки персональных данных. В случае несогласия с условиями пользователь должен воздержаться от использования Приложения. ", -1)),
            _cache[9] || (_cache[9] = _createElementVNode("p", null, " Оператор обеспечивает конфиденциальность персональных данных и принимает необходимые меры для их защиты в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных». ", -1)),
            _cache[10] || (_cache[10] = _createElementVNode("h2", null, "2. Персональные данные", -1)),
            _cache[11] || (_cache[11] = _createElementVNode("p", null, " Приложение может собирать и обрабатывать следующие данные: имя, фамилия, адрес электронной почты, номер телефона, логин и пароль (в зашифрованном виде), данные об использовании разделов Приложения (тренинги, тестирование, тренировки, подписки, мероприятия), технические данные устройства (тип ОС, версия приложения) для обеспечения работоспособности и улучшения сервиса. ", -1)),
            _cache[12] || (_cache[12] = _createElementVNode("p", null, " Номер телефона запрашивается при оформлении платных подписок и регистрации на платные мероприятия — для связи с пользователем по вопросам оплаты и оказания услуг. ", -1)),
            _cache[13] || (_cache[13] = _createElementVNode("h2", null, "3. Цели обработки", -1)),
            _cache[14] || (_cache[14] = _createElementVNode("p", null, " Персональные данные используются для предоставления доступа к материалам и услугам Приложения, идентификации пользователя, связи с пользователем (в том числе по телефону и e-mail), оформления и исполнения платных подписок и мероприятий, улучшения работы Приложения и исполнения договора оферты. ", -1)),
            _cache[15] || (_cache[15] = _createElementVNode("h2", null, "4. Защита данных", -1)),
            _cache[16] || (_cache[16] = _createElementVNode("p", null, " Оператор принимает организационные и технические меры для защиты персональных данных от неправомерного доступа, уничтожения, изменения, блокирования, копирования и распространения. ", -1)),
            _cache[17] || (_cache[17] = _createElementVNode("h2", null, "5. Права пользователя", -1)),
            _createElementVNode("p", null, [
              _cache[3] || (_cache[3] = _createTextVNode(" Пользователь вправе запросить доступ к своим персональным данным, их уточнение, блокирование или удаление. Порядок удаления аккаунта и связанных данных описан на странице ", -1)),
              _createVNode(_component_router_link, {
                to: "/account-deletion",
                class: "privacy-link"
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("Удаление аккаунта", -1)
                ]))]),
                _: 1
              }),
              _cache[4] || (_cache[4] = _createTextVNode(". ", -1))
            ]),
            _cache[18] || (_cache[18] = _createElementVNode("h2", null, "6. Договор оферты", -1)),
            _cache[19] || (_cache[19] = _createElementVNode("p", null, " Использование Приложения и оказание услуг регулируются также условиями публичной оферты. С полным текстом договора оферты можно ознакомиться по ссылке: ", -1)),
            _createElementVNode("a", {
              href: _ctx.offerUrl,
              target: "_blank",
              rel: "noopener noreferrer",
              class: "privacy-link"
            }, _toDisplayString(_ctx.offerUrl), 9, _hoisted_2),
            _cache[20] || (_cache[20] = _createElementVNode("p", null, " Дополнение к оферте (платные события) доступно в приложении: ", -1)),
            _createVNode(_component_router_link, {
              to: "/offer-supplement",
              class: "privacy-link"
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode("Дополнение к оферте — платные события", -1)
              ]))]),
              _: 1
            }),
            _cache[21] || (_cache[21] = _createElementVNode("h2", null, "7. Изменения", -1)),
            _cache[22] || (_cache[22] = _createElementVNode("p", null, " Оператор вправе вносить изменения в настоящую Политику конфиденциальности. Актуальная версия всегда доступна в Приложении. Продолжение использования Приложения после публикации изменений означает принятие обновлённой Политики. ", -1)),
            _cache[23] || (_cache[23] = _createElementVNode("p", { class: "privacy-footer" }, " © Национальная лига тренеров ", -1))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}